// extracted by mini-css-extract-plugin
export var columnList = "_au-0";